import { type Common } from '../common.js';
import { type SearchResult } from '../models/previsit/directory.js';

export class API {
  common: Common;
  baseEndpoint: string;
  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/patient-previsit/directory';
  }

  async getSearchResults(slug: string, query: string): Promise<SearchResult[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${slug}/search`);

    return await this.common.postJSON(url, { query });
  }
}
